
import { defineComponent } from '@vue/runtime-core';
import FinalPage from '@/Study/Pages/Final.vue';

export default defineComponent({
    components: { FinalPage }
});
